import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ModernLandingPage } from '../components/landing/ModernLandingPage';

export default function LandingPage() {
  const { user } = useAuth();

  // If user is already authenticated, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  // Show the modern landing page
  return <ModernLandingPage />;
}